import React, { useEffect, useMemo, useRef, useState } from "react";
import { NavLink as RouterLink } from "react-router-dom";


/* ✅ ONLY HERO VIDEO */
const LEP_ASSETS = {
  hero: {
    type: "mp4",
    video: "/videos/Rajneeti/Rajneeti2.mp4",
  },
};


/* ✅ Simple section card */
function LepSection({ title, children }) {

  return (
    <div className="row g-4 mt-4">
      <div className="col-12">
        <div className="lep-card lep-text lep-div-text">
          {title ? <h3 className="white mb-2">{title}</h3> : null}
          <div className="lep-mod-body">{children}</div>
        </div>
      </div>
    </div>
  );
}
function HraServiceWidget({
  icon = "🔷",
  title,
  desc,
  href,
  to,
  btnName
}) {
  return (
    <div className="hra-widget" role="article">
      <div className="hra-widget__icon" aria-hidden="true">
        {icon}
      </div>

      <h4 className="hra-widget__title">{title}</h4>

      <p className="hra-widget__desc">{desc}</p>

      {to ? (
        <RouterLink to={to} className="hra-widget__cta">
          {btnName}
          <span className="hra-widget__ctaArrow" aria-hidden>
            →
          </span>
        </RouterLink>
      ) : (
        <button
          type="button"
          className="hra-widget__cta"
          onClick={() =>
            window.open(href, "_blank", "noopener,noreferrer")
          }
        >
          {btnName}
          <span className="hra-widget__ctaArrow" aria-hidden>
            →
          </span>
        </button>
      )}
    </div>
  );
}
function LeadershipEmpowermentPrograms() {
  /* ✅ HERO VIDEO controls */
  const [isMuted, setIsMuted] = useState(true); // autoplay-friendly
  const [isPlaying, setIsPlaying] = useState(true);
  const topVideoRef = useRef(null);

  // Autoplay on mount
  useEffect(() => {
    const v = topVideoRef.current;
    if (!v) return;

    v.muted = isMuted;
    v.playsInline = true;

    v.play()
      .then(() => setIsPlaying(true))
      .catch(() => setIsPlaying(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const v = topVideoRef.current;
    if (!v) return;
    v.muted = isMuted;
  }, [isMuted]);

  const togglePlayPause = async () => {
    const v = topVideoRef.current;
    if (!v) return;

    if (v.paused) {
      try {
        await v.play();
        setIsPlaying(true);
      } catch {
        setIsPlaying(false);
      }
    } else {
      v.pause();
      setIsPlaying(false);
    }
  };

  const toggleMute = () => setIsMuted((m) => !m);

  /* ✅ CONTENT */
  const sections = useMemo(
    () => [
      {
        key: "after-video",
        title: "Programs Include",
        content: (
          <ul className="white arrow-list">
            <li>Youth Leadership Academy</li>
            <li>Women’s Leadership Circle</li>
            <li>Public Speaking &amp; Debate Programs</li>
            <li>Internship Pipelines</li>
            <li>Community Organizing Basics</li>
            <li>Mentorship Networks</li>
          </ul>
        ),
      },
      
    ],
    []
  );
  
  return (
    <>
      <style>{`
        html, body { overflow-x: hidden; }

        .section-title-body ul,
        .section-title-body ol { text-align: left !important; }
        .section-title-body li { text-align: left !important; }

        .block.color-scheme-4{
          padding-left: 0 !important;
          padding-right: 0 !important;
          overflow-x: hidden;
        }

        .lep-topWrap{
          max-width: 980px;
          margin: 0 auto 18px;
          padding: 6px 6px 0;
          text-align: center;
        }
        .lep-topTitle{
          margin: 0;
          line-height: 1.1;
          font-size: clamp(28px, 4vw, 44px);
          font-weight: 800;
          letter-spacing: 0.01em;
        }
        .lep-topIntro{
          margin: 10px auto 0;
          max-width: 860px;
          opacity: 0.96;
          font-size: 16px;
          line-height: 1.55;
        }

        /* ✅ TRUE FULL-WIDTH VIDEO */
        .lep-fullVideo{
          width: 90%;
  max-width: 1600px;
  margin: 40px auto;
  height: auto;
  background: #000;
  position: relative;
  overflow: visible;
}
        .lep-fullVideo video{
          width: 100%;
  height: auto;
  object-fit: contain;
}

        .lep-videoControls{
          position: absolute;
          top: auto;
          right: auto;
          bottom: 16px;
          left: 16px;
          display: flex;
          gap: 10px;
          z-index: 3;
        }
        .lep-ctrlBtn{
          border: 1px solid rgba(255,255,255,0.22);
          background: rgba(0,0,0,0.45);
          color: #fff;
          border-radius: 999px;
          padding: 10px 14px;
          font-size: 13px;
          letter-spacing: 0.02em;
          backdrop-filter: blur(10px);
          cursor: pointer;
          white-space: nowrap;
        }
        .lep-ctrlBtn:hover { background: rgba(0,0,0,0.6); }

        .lep-card {
          border-radius: 18px;
          overflow: hidden;
          background: rgba(255,255,255,0.06);
          border: 1px solid rgba(255,255,255,0.12);
          position: relative;
        }
        .lep-div-text{
          padding: 18px;
          text-align: left;
        }
        /* ===== READY TO BEGIN SECTION ===== */

.hra-begin-fixed{
  height: 420px;
}

.hra-begin-fixed .hra-widget{
  height: 100%;
  display: flex;
  flex-direction: column;
}

.hra-begin-fixed .hra-widget__desc{
  flex: 1 1 auto;
  min-height: 0 !important;
}

.hra-begin-fixed .hra-widget__cta{
  margin-top: auto;
}

.hra-widget{
  position: relative;
  border-radius: 22px;
  background: #fff;
  border: 1px solid rgba(0,0,0,.12);
  box-shadow: 0 8px 24px rgba(0,0,0,.08);
  padding: 22px 22px 20px;
  text-align: left;
  overflow: hidden;
  transition: transform 220ms ease,
              box-shadow 220ms ease,
              border-color 220ms ease;
}

.hra-widget:hover{
  transform: translateY(-4px);
  box-shadow: 0 14px 40px rgba(0,0,0,.18);
}

.hra-widget__icon{
  width: 54px;
  height: 54px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  font-size: 28px;
  margin-bottom: 12px;
  background: #0b3a96;
  color: #fff;
}

.hra-widget__title{
  margin: 0 0 8px 0;
  font-weight: 800;
  font-size: 22px;
  color: #0e1a2b;
}

.hra-widget__desc{
  margin: 0 0 16px 0;
  color: #1e2430;
  line-height: 1.55;
  min-height: 96px;
}

.hra-widget__cta{
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-radius: 999px;
  border: 0;
  background: #0b3a96;
  color: #fff;
  font-weight: 700;
  cursor: pointer;
  transition: 0.2s;
}

.hra-widget__cta:hover{
  transform: translateY(-2px);
}

.hra-widget__ctaArrow{
  transition: transform 220ms ease;
}

.hra-widget__cta:hover .hra-widget__ctaArrow{
  transform: translateX(3px);
}
.section-divider{
  width:100%;
  max-width:900px;
  margin:32px auto 38px;

  display:flex;
  align-items:center;
  justify-content:center;
  gap:18px;
}

.section-divider::before,
.section-divider::after{
  content:"";
  flex:1;
  height:3px;

  background: linear-gradient(
    to right,
    transparent,
    #1a2a5a,
    #d4af37,
    transparent
  );

  border-radius:10px;

  box-shadow:
    0 2px 6px rgba(0,0,0,0.18);
}

.section-divider span{
  font-size:26px;
  color:#1a2a5a;
  text-shadow:0 2px 6px rgba(0,0,0,0.15);

  animation: dividerGlow 2.5s ease-in-out infinite;
}
        @media (max-width: 768px) {
          .lep-videoControls{ bottom: 6px; left: 6px; gap: 4px; }
          .lep-ctrlBtn{ min-width: 42px; height: 22px; padding: 0 6px; border-radius: 6px; font-size: 8px; line-height: 1.1; font-weight: 700; letter-spacing: 0; background: rgba(10, 14, 22, 0.74); box-shadow: 0 2px 8px rgba(0,0,0,0.28); }
        }
      `}</style>

      <section>
        <div className="block color-scheme-4">
          {/* ✅ Heading + small content */}
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-9">
                <div className="lep-topWrap">
                  <h1 className="head-title hra-topTitle"><span>LEADERSHIP EMPOWERMENT PROGRAMS</span><div className="section-divider">
  <span>✦ ✦ ✦</span>
</div> </h1>
                  <p className="hra-topIntro">
                    These programs cultivate confident leaders for civic, academic, community, and political roles.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* ✅ VIDEO (FULL browser width) */}
          <div className="lep-fullVideo">
            <video
              ref={topVideoRef}
              src={LEP_ASSETS.hero.video}
              playsInline
              muted={isMuted}
              autoPlay
              loop
              preload="metadata"
              onPlay={() => setIsPlaying(true)}
              onPause={() => setIsPlaying(false)}
            />
            <div className="lep-videoControls">
              <button type="button" className="lep-ctrlBtn" onClick={togglePlayPause}>
                {isPlaying ? "Pause ⏸️" : "Play ▶️"}
              </button>
              <button type="button" className="lep-ctrlBtn" onClick={toggleMute}>
                {isMuted ? "Unmute 🔊" : "Mute 🔇"}
              </button>
            </div>
          </div>

          {/* ✅ Remaining content AFTER video */}
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 col-lg-9">
                <div className="section-sub-title center">
                  <article className="section-title-body white">
                    {sections.map((s) => (
                      <LepSection key={s.key} title={s.title}>
                        {s.content}
                      </LepSection>
                    ))}
                    {/* READY TO BEGIN SECTION */}

<div className="row g-4 mt-5">

  <div className="col-12">
    <h2 className="white text-center mb-4">
      <strong>Ready to begin?</strong>
    </h2>
  </div>

  <div className="col-12 col-md-6">
    <div className="hra-begin-fixed">
      <HraServiceWidget
        icon="🎓"
        title="Enroll & Attend Live Sessions"
        btnName="ENROLL"
        href="https://tinyurl.com/A4HRAJNEETIACADEMYONLINE"
        desc="Start learning through structured courses and participate in live weekly sessions with policy leaders, campaign experts, and community organizers."
      />
    </div>
  </div>

  

  <div className="col-12 col-md-6">
    <div className="hra-begin-fixed">
  <HraServiceWidget
    icon="🤝"
    title="A4H Volunteer"
    btnName="Become Volunteer"
    to="/5o1c3-volunteer"
    desc="Join disciplined grassroots efforts and build practical advocacy skills."
  />
</div>
  </div>

</div>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default LeadershipEmpowermentPrograms;
